<template>
  <FormWrapper>
    <template slot="head">
      <h3 class="kt-login__title">&nbsp;</h3>

      <BaseAlertMessage />

      <div class="alert alert-warning fade show text-left" v-show="!isAllowedBrowser">
        <div class="alert-icon text-white">
          <BaseIcon type="fas" icon="exclamation-triangle" size="2x" />
        </div>
        <div class="alert-text text-white">
          <strong>Your Browser is not supported.</strong>
          <div>Please install the latest version of Chrome.</div>
        </div>
      </div>
    </template>

    <form class="kt-form" @submit.prevent="signIn">

      <div class="alert alert-danger fade" :class="{ 'show': errorMessage }" v-if="errorMessage">
        <div class="alert-icon"><BaseIcon type="fas" icon="exclamation-triangle" size="2x" /></div>
        <div class="alert-text">{{ errorMessage }}</div>
        <div class="alert-close">
          <button type="button" class="close text-white" @click="closeAlert">
            <span aria-hidden="true"><BaseIcon type="fas" icon="times" size="sm" /></span>
          </button>
        </div>
      </div>

      <div class="form-group">
        <BaseInputForm
          :disabled="!isAllowedBrowser"
          v-model="email"
          type="text"
          placeholder="Email"
          autocomplete="off"
          :autofocus="true"
          required
          v-tid:signin-email />
      </div>

      <div class="form-group no-border">
        <BaseInputForm
          :disabled="!isAllowedBrowser"
          v-model="password"
          :className="`form-control-last`"
          type="password"
          placeholder="Password"
          required
          v-tid:signin-password />
      </div>

      <div class="kt-login__extra">
        <label class="kt-checkbox" v-if="rememberMe">
          <input type="checkbox" name="remember" disabled> Remember me
          <span></span>
        </label>
        <router-link :to="{ name: 'password-recovery' }">Forgot Password ?</router-link>
      </div>

      <div class="kt-login__actions pt-2">
        <BaseButton type="submit" classButton="btn btn-icon-box  btn-primary btn-labeled" v-tid:signin-button :disabled="!isAllowedBrowser">
          <span v-if="!isLoading">SIGN IN <span class="btn-label"><font-awesome-icon :icon="['fas', 'sign-in-alt']"/></span></span>
          <span v-if="isLoading"><font-awesome-icon :icon="['fas', 'spinner']" spin class="mr-1" /></span>
        </BaseButton>
      </div>
    </form>

  </FormWrapper>
</template>

<script>
import FormWrapper from '@/components/login/FormWrapper.vue'
import NProgress from 'nprogress'

export default {
  name: 'FormSignin',
  data () {
    return {
      email: '',
      password: '',
      errorMessage: null,
      isLoading: false
    }
  },
  components: {
    FormWrapper
  },
  computed: {
    isAllowedBrowser () {
      return this.isBrowserChrome || this.isBrowserFirefox
    },
    isBrowserChrome () {
      return !!window.chrome
    },
    isBrowserFirefox () {
      return navigator.userAgent.toLowerCase().indexOf('firefox') > -1
    }
  },
  props: {
    rememberMe: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    signIn () {
      NProgress.start()
      this.isLoading = true
      const credentials = { email: this.email, password: this.password }
      this.$store
        .dispatch('auth/getToken', credentials)
        .then(() => {
          this.isLoading = false
          // Redirect to the originally requested page, or to the home page
          this.$router.push(this.$route.query.redirect || { name: 'home' })
        })
        .catch((error) => {
          this.isLoading = false
          this.errorMessage = error.response.data.message
          NProgress.done()
        })
    },
    closeAlert () {
      this.errorMessage = null
    }
  }
}
</script>
